<template>
    <v-container flud>
        <v-row>
            <v-col
                    md="6"
                    offset-md="3">
                <p
                        class="text-sm-center display-2"
                >
                    Our Promos</p>
                <v-divider
                 class="mb-10"></v-divider>
                <PromoCard v-for="promo in promos" :key="promo.id" :promo="promo" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PromoService from "../services/PromoService";
    import PromoCard from "../components/PromoCard"
    export default {
        name: "ShowPromos",
        components: {PromoCard},
        data() {
            return {
                promos: []
            }
        },
        created() {
            PromoService.getPromos()
                .then(response => {
                    this.promos = response.data
                })
        }
    }

</script>

<style scoped>
</style>